function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#222428;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Calque_2"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Calque_1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.7,12.9h16.9c0.9,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H10.7c-0.9,0-1.5,0.7-1.5,1.5S9.9,12.9,10.7,12.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M18.6,32.7h-7.9c-0.9,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h7.9c0.9,0,1.5-0.7,1.5-1.5S19.5,32.7,18.6,32.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.7,20.3h16.9c0.9,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H10.7c-0.9,0-1.5,0.7-1.5,1.5S9.9,20.3,10.7,20.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M34.6,2.3H3.7C2.8,2.3,2.1,3,2.1,3.9v41.1c0,0.5,0.3,1.1,0.8,1.4c0.5,0.2,1.1,0.2,1.5-0.1L11,42l7.1,2.8 c0.4,0.1,0.8,0.2,1.2,0l5-2.1l9.7,4.4l0.1,0c0.1,0,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,0.9-0.2c0.4-0.3,0.7-0.8,0.7-1.3V3.9 C36.1,3,35.5,2.3,34.6,2.3z M33,5.4v37.9l-8.1-3.7l-0.1,0c-0.1,0-0.3-0.1-0.5-0.1c-0.2,0-0.4,0-0.6,0.1l-5,2.1l-7.3-2.9 c-0.5-0.2-1-0.1-1.4,0.2l-4.8,3.1V5.4H33z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.7,27.7h16.9c0.9,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H10.7c-0.9,0-1.5,0.7-1.5,1.5S9.9,27.7,10.7,27.7z"
})));

var SvgOrder = function SvgOrder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 38.6 48.9",
    style: {
      enableBackground: "new 0 0 38.6 48.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/order.e3d2a537.svg";
export { ForwardRef as ReactComponent };